import { useEditableFieldsContext } from 'modules/templateEditor/context/EditableFieldsContext';
import { useQueryParamContext } from 'modules/templateEditor/context/QueryParamContext';
import { useTemplateQueryContext } from 'modules/templateEditor/context/TemplateQueryContext';
import { SEGMENT_TRACKED_TEMPLATE_ACTION_TRIGGERS } from 'modules/templateIndex/constants';
import { CopyTemplateModal as CommonCopyTemplateModal } from 'modules/templateIndex/modals';
import { useLocalesQueryContext } from 'modules/campaigns/lib/contexts/LocalesQueryContext';
import { ContentModalStateType, useModalContext } from 'utils/contexts/modal';
import noop from 'utils/noop';
import {
  getCopyModalTemplateFormat,
  getIsCopyTemplateModalVisible,
  getLocalesToCopy,
} from './CopyTemplateModal.utils';

export const CopyTemplateModal = () => {
  const { medium } = useTemplateQueryContext();
  const { campaignId } = useQueryParamContext();
  const { liveTemplate } = useEditableFieldsContext();
  const { activeTemplateLocales } = useLocalesQueryContext();
  const { modalState, hideModal } = useModalContext<ContentModalStateType>();
  const { mediumData } = liveTemplate;

  if (!getIsCopyTemplateModalVisible(modalState)) return null;

  const localesToCopy = getLocalesToCopy(activeTemplateLocales);

  // this is a special modal that needs its logic to remain mounted in order to catch the new value
  // of destTemplateId so that it can redirect to the new template upon success (so we only
  // show/hide the renderable piece)
  return (
    <CommonCopyTemplateModal
      currentCampaignId={campaignId}
      template={getCopyModalTemplateFormat(medium, liveTemplate, mediumData, localesToCopy)}
      closeModal={hideModal}
      refetch={noop}
      triggeredBy={SEGMENT_TRACKED_TEMPLATE_ACTION_TRIGGERS.TEMPLATE_EDITOR_ACTIONS}
    />
  );
};
